module.exports = __webpack_public_path__ + "static/media/signinBg.3abc6578.png";